export default "/images/vendor/flag-icon-css/flags/1x1/dz.svg?2be2fee6433a59e75c3da92d5f366470";